<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
  {{ body }}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary mx-1" (click)="cancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-secondary mx-1" (click)="confirm()">
    Confirm
  </button>
</div>
